module.exports = __webpack_public_path__ + "img/banner_en.185f4582.jpg";